// Single access point for the app version (from the repo-root VERSION file via
// vite.config.ts). Use this rather than the raw __APP_*__ globals.
export const appVersion = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  buildTime: __BUILD_TIME__,
} as const;
